import { AbstractControl, ValidationErrors } from '@angular/forms';

export function municipalityCodeValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.trim();

  if (!value) {
    return null;
  }

  if (value.length <= 3) {
    return null;
  }

  if (value.length === 4 && value[0] === '0') {
    const dataHubMunicipalityCode = Number(value.substring(1));
    if (Number.isInteger(dataHubMunicipalityCode) && dataHubMunicipalityCode >= 100 && dataHubMunicipalityCode <= 999) {
      return null;
    }
  }

  return { municipalityCode: true };
}
